import { createActions, createReducer } from "reduxsauce"

const { Types, Creators } = createActions({
  setShopTags: ["shopTags"],
  getProductsByTag: ["tag"],
  getProductsList: [
    "page",
    "brand",
    "category",
    "subCategory",
    "order",
    "slider",
    "search",
    "subCategoryI",
    "tag",
  ],
  setProductsList: ["productsList"],
  getProductDetails: ["Product_id", "prd_supp"],
  setProductDetails: ["productD"],
  getBrands: [],
  setBrands: ["brands"],
  getDefaultProducts: [],
  setDefaultProducts: ["defaultProducts"],
  getCategories: [],
  setCategories: ["categories"],
  setManufacturer: ["isSelectedManufacturer"],
  setCategory: ["isSelectedCategory"],
  setSubCategory: ["isSelectedSubCategory"],
  setSubSubCategory: ["isSelectedSubSubCategory"],
  setOrderVal: ["orderVal"],
  setSliderVal: ["sliderVal"],
  checkOut: ["formData", "resetFields","is_sepafin","username"],
  setOrderDetails: ["orderD"],

  getToCart: ["prd_supp", "Product_id", "list", "quantity", "from"],
  setToCart: ["productCart"],

  getItemsCart: ["checkout"],
  setItemsCart: ["itemsCart"],

  getOrder: [
    "products_array",
    "iso_code",
    "postcode",
    "carrier",
    "first_name",
    "last_name",
    "city",
    "address",
    "phone",
    "email",
  ],
  setOrder: ["orders"],

  getRemoveToCart: ["prd_supp", "Product_id", "quantity", "list"],
  setRemoveToCart: ["productRemovedCart"],

  getCarries: ["iso_code", "postcode"],
  setCarries: ["carries"],
  setSelectedCap: ["selectedCap"],
  getProdCat: ["category", "subCategory"],
  setProdCat: ["prodCat"],
  openProducts: ["areOpenProducts"],
  setShopLeftMenuMob: ["shopLeftMenuMob"],
  showLoader: ["hasLoader"],
  getOrders: ["skinId"],
  setOrders: ["ordersShop"],
  getOrderData: ["order_id"],
  setOrderData: ["orderData"],
  getCoffeeServices: [],
  setCoffeeServices: ["coffeeServices"],
  buyCaffe: [
    "products_array",
    "nome",
    "cognome",
    "codice_fiscale",
    "nome_societa",
    "paese",
    "address",
    "email",
    "telefono",
    "citta",
    "provincia",
    "cap",
  ],
  getCoffeeAddress: ["barcode", "paymentDetails"],
  setCoffeAddress: ["coffeePaymentDetails"],
  setCoffeeLoader: ["coffeLoader"],
  setCoffeeBuyingLoader: ["coffeBuyingLoader"],
})

export const ShopTypes = Types
export default Creators

const INITIAL_STATE = {
  shopTags: {},
  productsList: {},
  coffeeServices: [],
  productD: {},
  brands: {},
  defaultProducts: {},
  categories: {},
  isSelectedManufacturer: null,
  isSelectedCategory: null,
  isSelectedSubCategory: null,
  isSelectedSubSubCategory: null,
  orderVal: "",
  sliderVal: [],
  coffeePaymentDetails: {},
  productCart: "",
  itemsCart: {},
  orders: {},
  productRemovedCart: {},
  carries: [],
  selectedCap: "",
  prodCat: {},
  areOpenProducts: false,
  shopLeftMenuMob: false,
  hasLoader: false,
  orderD: {},
  ordersShop: [],
  orderData: {},
  coffeLoader: false,
  coffeBuyingLoader: false,
}

export const reducer = createReducer(INITIAL_STATE, {
  SET_COFFEE_BUYING_LOADER: (state, { coffeBuyingLoader }) => ({
    ...state,
    coffeBuyingLoader,
  }),
  SET_COFFEE_LOADER: (state, { coffeLoader }) => ({
    ...state,
    coffeLoader,
  }),
  SET_COFFE_ADDRESS: (state, { coffeePaymentDetails }) => ({
    ...state,
    coffeePaymentDetails,
  }),
  SET_COFFEE_SERVICES: (state, { coffeeServices }) => ({
    ...state,
    coffeeServices,
  }),
  SET_SHOP_TAGS: (state, { shopTags }) => ({
    ...state,
    shopTags,
  }),
  SET_SHOP_LEFT_MENU_MOB: (state, { shopLeftMenuMob }) => ({
    ...state,
    shopLeftMenuMob,
  }),
  SET_PRODUCTS_LIST: (state, { productsList }) => ({
    ...state,
    productsList,
  }),
  SET_PRODUCT_DETAILS: (state, { productD }) => ({
    ...state,
    productD,
  }),
  SET_BRANDS: (state, { brands }) => ({
    ...state,
    brands,
  }),
  SET_DEFAULT_PRODUCTS: (state, { defaultProducts }) => ({
    ...state,
    defaultProducts,
  }),
  SET_CATEGORIES: (state, { categories }) => ({
    ...state,
    categories,
  }),
  SET_MANUFACTURER: (state, { isSelectedManufacturer }) => ({
    ...state,
    isSelectedManufacturer,
  }),

  SET_CATEGORY: (state, { isSelectedCategory }) => ({
    ...state,
    isSelectedCategory,
    sliderVal: [],
  }),
  SET_SUB_CATEGORY: (state, { isSelectedSubCategory }) => ({
    ...state,
    isSelectedSubCategory,
    sliderVal: [],
  }),
  SET_SUB_SUB_CATEGORY: (state, { isSelectedSubSubCategory }) => ({
    ...state,
    isSelectedSubSubCategory,
    sliderVal: [],
  }),
  SET_ORDER_VAL: (state, { orderVal }) => ({
    ...state,
    orderVal,
  }),
  SET_SLIDER_VAL: (state, { sliderVal }) => ({
    ...state,
    sliderVal,
  }),

  SET_TO_CART: (state, { productCart }) => ({
    ...state,
    productCart,
  }),
  SET_ITEMS_CART: (state, { itemsCart }) => ({
    ...state,
    itemsCart,
  }),
  SET_ORDER: (state, { orders }) => ({
    ...state,
    orders,
  }),
  SET_REMOVE_TO_CART: (state, { productRemovedCart }) => ({
    ...state,
    productRemovedCart,
  }),
  SET_CARRIES: (state, { carries }) => ({
    ...state,
    carries,
  }),
  SET_SELECTED_CAP: (state, { selectedCap } )=> ({
    ...state,
    selectedCap,
  }),
  SET_PROD_CAT: (state, { prodCat }) => ({
    ...state,
    prodCat,
  }),
  OPEN_PRODUCTS: (state, { areOpenProducts }) => ({
    ...state,
    areOpenProducts,
  }),
  SHOW_LOADER: (state, { hasLoader }) => ({
    ...state,
    hasLoader,
  }),
  SET_ORDER_DETAILS: (state, { orderD }) => ({
    ...state,
    orderD,
  }),

  SET_ORDERS: (state, { ordersShop }) => ({
    ...state,
    ordersShop,
  }),
  SET_ORDER_DATA: (state, { orderData }) => ({
    ...state,
    orderData,
  }),
})
